import { Container } from "@common-ui/ui";
import { LicenseInfo } from "@mui/x-data-grid-pro";

import CustomerDetails from "./pages/CustomerDetails";
import Addresses from "./pages/Addresses";
import Contacts from "./pages/Contacts";
import { Places } from "./places";

LicenseInfo.setLicenseKey(process.env.REACT_APP_DATA_GRID_LICENSE);

export const CustomerProfile = ({
  orgId,
  isSuccess,
  setIsSuccess,
  customerDetails,
  addresses,
  contacts,
  appRole,
}) => {
  return (
    <>
      <CustomerDetails
        orgId={orgId}
        customerDetails={customerDetails}
        setIsSuccess={setIsSuccess}
        doesUserHavePermission={appRole === "ADMIN"}
      />
      <Container maxWidth="md" component="main">
        <Addresses
          orgId={orgId}
          isSuccess={isSuccess}
          setIsSuccess={setIsSuccess}
          addresses={addresses}
          customerId={customerDetails.system_id}
          doesUserHavePermission={appRole === "ADMIN"}
        />
        <Contacts
          orgId={orgId}
          contacts={contacts}
          addresses={addresses}
          setIsSuccess={setIsSuccess}
          customerDetails={customerDetails}
          customerId={customerDetails.system_id}
          doesUserHavePermission={appRole === "ADMIN"}
        />
        <Places
          orgId={orgId}
          customerId={customerDetails.system_id}
          addresses={addresses}
          doesUserHavePermission={appRole === "ADMIN"}
        />
      </Container>
    </>
  );
};
